export default __webpack_public_path__ + "static/media/clincalnotes@2xwhite.da3088db.png";